import React from 'react';
import { FormattedMessage } from 'react-intl';

import { cloneDeep as _cloneDeep, some as _some, remove as _remove } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const formatEntityErrorsForDisplay = (entity, messages) => {
  const res = [];

  if (entity && !entity.isValid) {
    const errors = _cloneDeep(entity.errors);

    // check if item has errors in attributes
    if (_some(errors, error => error.validationResult.rule === 'itemAttributes')) {
      res.push(messages.validation_problems_with_item_attributes);
      _remove(errors, error => error.validationResult.rule === 'itemAttributes');
    }

    for (let i = 0; i < errors.length; i++) {
      const {
        fieldName,
        validationResult: { helpText },
      } = errors[i];

      res.push(
        <FormattedMessage
          id="the_field_name_contains_following_errors"
          values={{ fieldName: <b>{messages[fieldName] || fieldName}</b>, helpText: <b>{helpText}</b> }}
        />
      );
    }
  }

  return res;
};
